import AppImage from '@/components/ui/AppImage';

export default function HeroSection() {
  return (
    <section className="relative h-[500px] lg:h-[600px] overflow-hidden bg-gradient-to-br from-brand-primary/10 via-background to-accent/5">
      <div className="absolute inset-0">
        <AppImage
          src="https://img.rocket.new/generatedImages/rocket_gen_img_122d40d6f-1768858602345.png"
          alt="Diverse group of young students working together on hydroponic farming system with green plants in modern educational facility"
          className="w-full h-full object-cover opacity-20"
          priority />

      </div>
      
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-2 bg-brand-primary/10 rounded-full mb-6">
            <span className="text-sm font-semibold text-brand-primary">About Our Foundation</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text-primary mb-6 leading-tight">
            Growing Climate Leaders.<br />
            Building Future Innovators.
          </h1>
          
          <p className="sm:text-xl text-text-secondary mb-8 text-[28px]">Our mission is to empower food insecure communities with resilient and reliable resources.

          </p>
          
          <div className="flex flex-wrap gap-4">
            <div className="bg-white rounded-lg shadow-brand-md px-6 py-4">
              <div className="text-3xl font-bold text-brand-primary">600+</div>
              <div className="text-sm text-text-secondary">Pounds of Food Donated</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}